export function getPartnerLogo(partner) {
  if(partner.includes('longchamp')) {
    return 'https://octiapp.s3.eu-west-1.amazonaws.com/longchamp/img/logo.png'
  } else if(partner.includes('bompard')) {
    return 'https://octiapp.s3.eu-west-1.amazonaws.com/bompard/img/logo_2024.png'
  } else if (partner.includes('sandro')) {
    return 'https://octipas-sftp.s3.eu-west-1.amazonaws.com/smcp-digital-in-store/staging/img/sandro-logo.png'
  } else if (partner.includes('maje')) {
    return 'https://octipas-sftp.s3.eu-west-1.amazonaws.com/smcp-digital-in-store/staging/img/maje-logo-2026.png'
  } else if (partner.includes('claudie-pierlot')) {
    return 'https://octipas-sftp.s3.eu-west-1.amazonaws.com/smcp-digital-in-store/staging/img/claudie-pierlot-logo.png'
  } else if (partner.includes('the-kooples')) {
    return 'https://octiapp.s3.eu-west-1.amazonaws.com/the-kooples/tk-logo-2025.png'
  } else if (partner.includes('Louispion') || partner.includes('louis-pion')) {
    return 'https://octiapp.s3.eu-west-1.amazonaws.com/louispion/img/louispion-logo.png'
  } else if (partner.includes('nature-et-decouvertes')) {
    return 'https://octiapp.s3.eu-west-1.amazonaws.com/nature-et-decouvertes/img/logo.png'
  } else if (partner.includes('demo')) {
    return 'https://octipas-backoffices.s3.eu-west-3.amazonaws.com/logos/new-logo-octipas.png'
  } else {
    return null
  }
}

export default { getPartnerLogo }
